import { render, staticRenderFns } from "./CampaignPreOrdersTable.vue?vue&type=template&id=20a450ce&"
import script from "./CampaignPreOrdersTable.vue?vue&type=script&lang=js&"
export * from "./CampaignPreOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPreOrdersTable.vue?vue&type=style&index=0&id=20a450ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports